import { useState } from 'react'

import {
  getScheduledDateTimeValidity,
  toScheduledTimestamp,
  withoutPastScheduledTime,
} from './helpers'

// Note: errors are only shown after the first submit attempt, then follow every change.
// `isPending` means `isRequired` isn't known yet (settings still loading) - submit stays blocked.
export const useScheduledDateTime = ({ isRequired = false, isPending = false, timezone }) => {
  const [date, setDate] = useState(null)
  const [time, setTime] = useState(null)
  const [isSubmitted, setIsSubmitted] = useState(false)

  const { isDateMissing, isTimeMissing } = getScheduledDateTimeValidity(date, time, isRequired)

  const handleDateChange = (nextDate) => {
    const next = withoutPastScheduledTime({ date: nextDate, time }, timezone)
    setDate(next.date)
    setTime(next.time)
  }

  const validate = () => {
    if (isPending) return false

    setIsSubmitted(true)
    return !isDateMissing && !isTimeMissing
  }

  return {
    isPending,
    fieldProps: {
      date,
      time,
      timezone,
      isRequired,
      onDateChange: handleDateChange,
      onTimeChange: setTime,
      isDateError: isSubmitted && isDateMissing,
      isTimeError: isSubmitted && isTimeMissing,
    },
    timestamp: toScheduledTimestamp(date, time, timezone),
    validate,
  }
}
